/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Receive filter for a group or user.
 * @export
 * @interface ReceiveFilter
 */
export interface ReceiveFilter {
    /**
     * List of allowed countries
     * @type {Array<number>}
     * @memberof ReceiveFilter
     */
    countries?: Array<number>;
    /**
     * List of allowed regions
     * @type {Array<string>}
     * @memberof ReceiveFilter
     */
    regions?: Array<string>;
    /**
     * List of allowed source tags
     * @type {Array<object>}
     * @memberof ReceiveFilter
     */
    sourceTags?: Array<object>;
    /**
     * List of UIDs allowed areas
     * @type {Array<object>}
     * @memberof ReceiveFilter
     */
    areas?: Array<object>;
    /**
     * Filter expression
     * @type {string}
     * @memberof ReceiveFilter
     */
    expression?: string;
}

/**
 * Check if a given object implements the ReceiveFilter interface.
 */
export function instanceOfReceiveFilter(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReceiveFilterFromJSON(json: any): ReceiveFilter {
    return ReceiveFilterFromJSONTyped(json, false);
}

export function ReceiveFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceiveFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'countries': !exists(json, 'countries') ? undefined : json['countries'],
        'regions': !exists(json, 'regions') ? undefined : json['regions'],
        'sourceTags': !exists(json, 'source_tags') ? undefined : json['source_tags'],
        'areas': !exists(json, 'areas') ? undefined : json['areas'],
        'expression': !exists(json, 'expression') ? undefined : json['expression'],
    };
}

export function ReceiveFilterToJSON(value?: ReceiveFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'countries': value.countries,
        'regions': value.regions,
        'source_tags': value.sourceTags,
        'areas': value.areas,
        'expression': value.expression,
    };
}

